import UpdateEncryptionDrawer from "./UpdateEncription";

const accountDrawersComponents = {
  UpdateEncryptionDrawer
}

export default accountDrawersComponents;